export const colors = Object.freeze({
  gray: {
    darken2: '#646464',
    darken1: '#AEAEAE',
    base: '#C8C8C8',
    lighten1: '#E0E0E0',
    lighten2: '#F3F3F3',
    lighten3: '#FAFAFA'
  },
  pink: {
    lighten2: '#FFF4F9',
    lighten1: '#FFDFEE',
    base: '#FFCAE3'
  },
  blue: {
    lighten2: '#CDD4E7',
    lighten1: '#677EB8',
    base: '#002788'
  },
  bourgogne: {
    lighten2: '#E2CDDC',
    lighten1: '#A96C97',
    base: '#6E0850'
  },
  brown: {
    lighten2: '#ECD7D0',
    lighten1: '#C68773',
    base: '#A13716'
  },
  lime: {
    lighten2: '#EBF3D2',
    lighten1: '#C3DB78',
    base: '#9BC31E'
  },
  cyan: {
    lighten2: '#ECF6FA',
    lighten1: '#C8E4F2',
    base: '#A5D3EB'
  },
  yellow: {
    lighten2: '#FFF1D2',
    lighten1: '#FDD678',
    base: '#FBBA1E'
  },
  red: {
    lighten2: '#FCD7D7',
    lighten1: '#F68888',
    base: '#F13A3A'
  },
  green: {
    lighten2: '#CFE2D6',
    lighten1: '#6DA784',
    base: '#0D6D32'
  }
})

export default function () {
  return {
    theme: {
      dark: false,
      default: 'light',
      options: {
        customProperties: true
      },
      themes: {
        light: {
          gray: colors.gray,
          primary: colors.blue,
          secondary: colors.pink,
          tertiary: colors.bourgogne,
          quaternary: colors.brown,
          quinary: colors.lime,
          info: colors.cyan,
          warning: colors.yellow,
          error: colors.red,
          success: colors.green
        }
      }
    },
    icons: {
      iconFont: false,
      values: {
        sliders: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'sliders'] }
        },
        search: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'search'] }
        },
        check: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'check'] }
        },
        eye: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'eye'] }
        },
        eyeSlash: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'eye-slash'] }
        },
        /*
        * used by vuetify components internally
        */
        cancel: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fal', 'circle-xmark'] }
        },
        checkboxIndeterminate: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fal', 'square-minus'] }
        },
        checkboxOn: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'square-check'] }
        },
        checkboxOff: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'square'] }
        },
        checkboxSolidOn: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fas', 'square-check'] }
        },
        checkboxSolidOff: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fas', 'square'] }
        },
        radioOff: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'circle'] }
        },
        radioOn: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'circle-dot'] }
        },
        clear: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fal', 'xmark'] }
        },
        close: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'xmark'] }
        },
        complete: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'check'] }
        },
        delete: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fal', 'circle-xmark'] }
        },
        delimiter: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fas', 'circle'] }
        },
        dropdown: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fal', 'angle-down'] }
        },
        edit: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'pen-to-square'] }
        },
        error: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fas', 'triangle-exclamation'] }
        },
        expand: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'angle-down'] }
        },
        file: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'paperclip-vertical'] }
        },
        first: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'backward-step'] }
        },
        info: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fas', 'circle-info'] }
        },
        last: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'forward-step'] }
        },
        loading: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'rotate'] }
        },
        menu: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'bars'] }
        },
        minus: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'minus'] }
        },
        next: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'angle-right'] }
        },
        plus: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'plus'] }
        },
        prev: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'angle-left'] }
        },
        ratingEmpty: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'star'] }
        },
        ratingFull: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fas', 'star'] }
        },
        ratingHalf: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'star-half-stroke'] }
        },
        sort: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'arrow-up'] }
        },
        subgroup: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fas', 'caret-down'] }
        },
        success: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fas', 'circle-check'] }
        },
        unfold: {
          component: 'FontAwesomeIcon',
          props: { icon: ['fal', 'arrows-up-down'] }
        },
        warning: {
          component: 'FontAwesomeIcon',
          props: { icon: ['far', 'exclamation'] }
        }
      }
    }
  }
}
